export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-10 col-md-offset-1 intro-text'>

                {/* Eyebrow chip */}
                <div className='hero-chip'>
                  <span className='hero-chip-dot'></span>
                  India's Fastest-Growing Solar Installer
                </div>

                {/* Main headline */}
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span className='hero-highlight'> — Starting Today.</span>
                </h1>

                {/* Sub-copy */}
                <p className='hero-sub'>
                  {props.data ? props.data.paragraph : 'Loading'}
                </p>

                {/* Dual CTAs */}
                <div className='hero-ctas'>
                  <a href='#calculator' className='btn hero-btn-primary page-scroll'>
                    <i className='fa fa-bolt'></i> Calculate My Savings
                  </a>
                  <a href='#how-it-works' className='btn hero-btn-ghost page-scroll'>
                    <i className='fa fa-play-circle'></i> How It Works
                  </a>
                </div>

                {/* Social proof strip */}
                <div className='hero-proof'>
                  <div className='hero-proof-item'>
                    <strong>1,500+</strong><span>Installations</span>
                  </div>
                  <div className='hero-proof-divider'></div>
                  <div className='hero-proof-item'>
                    <strong>5+ MW</strong><span>Capacity Installed</span>
                  </div>
                  <div className='hero-proof-divider'></div>
                  <div className='hero-proof-item'>
                    <strong>7 Cities</strong><span>Pan-India Presence</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
